<script>
  import { onMount } from "svelte";
  export let value = "";
  export let name;
  export let label;
  export let empty;

  let activeElement;
  let picker;

  $: console.log(value);

  function setActive(e) {
    activeElement = (e && e.target) || null;
  }

  function handleInput(e) {
    typeof empty === "function" && empty();
    value = e.detail.value;
  }
  onMount(() => {
    const DATE_FORMAT = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
    console.log(picker);
    picker.dateAdapter = {
      parse(value = "", createDate) {
        const matches = value.match(DATE_FORMAT);
        console.log({ value, matches, createDate });
        if (matches) {
          return createDate(matches[3], matches[2], matches[1]);
        }
      },
      format(date) {
        return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      },
    };
  });
</script>

<div
  class="input-field"
  class:active={value || activeElement}
  class:invalid={empty}
>
  <label for={name}>{label}</label>
  <duet-date-picker
    identifier={name}
    {value}
    min="1900-01-01"
    bind:this={picker}
    on:duetBlur={() => setActive(null)}
    on:duetFocus={setActive}
    on:duetChange={handleInput}
  ></duet-date-picker>
</div>

<style>
  .input-field {
    margin-top: 35px;
    position: relative;
  }
  .input-field label {
    position: absolute;
  }
  input:required {
    box-shadow: none;
  }
  :global(duet-date-picker .duet-date input) {
    background-color: transparent;
    border: none;
    width: 100%;
    padding: 15px 0;
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
    border-radius: 0;
    transition:
      box-shadow ease 1s,
      border-bottom ease 1s;
  }
  :global(duet-date-picker .duet-date input::placeholder) {
    font-size: 0;
  }

  :global(duet-date-picker .duet-date__input:focus) {
    outline: none;
    box-shadow: none;
    border-color: var(--primary-color);
  }
  :global(duet-date-picker .duet-date button) {
    outline: none;
    box-shadow: none;
    background-color: transparent;
  }
  :global(.input-field.invalid duet-date-picker input) {
    box-shadow: 0 8px 6px -6px var(--alert-color);
  }
  .input-field label {
    transition: all 0.3s;
  }
  .active label {
    transform: scale(0.7) translateY(-100%);
    transform-origin: top left;
  }
  .active input {
    border-bottom: 2px solid var(--primary-color);
  }
  input.nofill {
    width: auto;
  }
</style>
